<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.5087 0C2.0175 0 0 2.0184 0 4.5087V19.4913C0 21.9825 2.0184 24 4.5087 24H19.4913C21.9825 24 24 21.9816 24 19.491V4.5087C24 2.0175 21.9816 0 19.491 0H4.5087ZM21 19.4913C21 20.325 20.3253 21 19.491 21H10.5V3H19.4913C20.325 3 21 3.6747 21 4.5087V19.4913ZM6.80534 16.3378L2.46763 12.0001L6.80534 7.66239L8.62362 9.48066L6.10418 12.0001L8.62362 14.5195L6.80534 16.3378Z"
    />
  </svg>
</template>
